import {
  Component,
  model,
  input,
  output,
  signal,
} from '@angular/core';
import { Modal } from 'flowbite';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-modal-change-driver-vehicle',
  templateUrl: './modal-change-driver-vehicle.html',
  styleUrl: './modal-change-driver-vehicle.scss',
  standalone: false,
})
export class ModalChangeDriverVehicle {
  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly clientId = input<number | undefined>();
  readonly assignedDriver = input<{ value: any; label: string }[]>([]);
  readonly assignedVehicle = input<{ value: any; label: string }[]>([]);
  driverSelected = model<any>();
  vehicleSelected = model<any>();
  timeSelected = model<string>();
  commentSelected = model<string>();
  readonly availabilitiesSelected = input<number>();
  readonly action = output<any>();
  readonly editing = input<boolean>();
  readonly hasTrips = input<boolean>();
  readonly hasBookings = input<boolean>();

  public images = images;

  assignedDriverOption() {
    return this.assignedDriver() ?? [];
  }

  assignedVehicleOption() {
    return this.assignedVehicle() ?? [];
  }
  public gtfsId: string = '';
  public updateTrips: boolean = true;
  public notify: boolean = true;
  public dateTime: Date;

  public optionsBus: AnimationOptions = {
    path: '/assets/animations/bus.json',
  };

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
  ) {}

  changeDriver(event: any) {
    this.driverSelected.set(event.value);
  }

  changeVehicle(event: any) {
    this.vehicleSelected.set(event.value);
  }

  changeTime(event: any) {
    const input = event.target as HTMLInputElement;
    let timeValue: string | undefined = input.value;
    if (timeValue == '') timeValue = undefined;
    this.timeSelected.set(timeValue);
    if (this.timeSelected() !== undefined) this.updateTrips = true;
  }

  changeComment(event: any) {
    this.commentSelected.set((event.target as HTMLTextAreaElement).value);
  }

  onSubmit() {
    this.action.emit({
      driverSelected: this.driverSelected(),
      vehicleSelected: this.vehicleSelected(),
      sendNotification: this.notify,
      updateTrips: this.updateTrips,
      timeSelected: this.timeSelected(),
      comment: this.commentSelected(),
    });
    this.timeSelected.set(undefined);
    this.vehicleSelected.set(undefined);
    this.driverSelected.set(undefined);
    this.commentSelected.set(undefined);
  }
}
